/**
 * Renders applied filter chips for the Global Search detailed view.
 * Each chip displays the filter id and human-readable label, with an
 * icon button to remove the chip by index.
 *
 * @component
 * @param {Object} props
 * @param {Array<{label: string, value: string}>} props.detailFilter List of applied filters to render as chips.
 * @param {Function} props.removeFilter Handler invoked with the chip index to remove the filter.
 * @returns {JSX.Element} A container of filter chips with remove controls.
 */
import React from "react";

import Icon from "@ant-design/icons";
import { Space } from "antd";

import { ReactComponent as Pending } from "@assets/images/svg/falseRed.svg";

function FilterChips({ detailFilter, removeFilter }) {
  return (
    <>
      <Space className="chips-container">
        {detailFilter?.map(({ value, displayValue, label }, index) => (
          <span key={index} className="filter-text">
            {`${label}: ${displayValue ?? value}`}
            <Icon component={Pending} className="p-1" onClick={() => removeFilter(index)} />
          </span>
        ))}
      </Space>
    </>
  );
}

export default FilterChips;
